module.exports = __webpack_public_path__ + "static/img/round_messages_icon.2905520.png";